// src/merch/stores.js
//
// White label. One app, many stores: each store gets its own address
// (e.g. design.sportsheadz.com), logo, name and accent colour, with a
// small "Powered by MerchMod" in the footer. merchmod.ca itself is the
// product overview, with the designer as a demo at merchmod.ca/demo.
//
// Adding a store:
//   1. add an entry below (id = short lowercase slug, used on orders)
//   2. point its domain at the Vercel project + add a rewrite for its host
//      in vercel.json (copy the merchmod.ca one)
//   3. add its origin to MERCH_STORE_ORIGINS in Supabase (comma-separated)
// Test any store before its domain exists with ?store=<id> (remembered
// for the browser tab).

export const STORES = {
  merchmod: {
    id: "merchmod",
    name: "MerchMod",
    logo: "/merch/MerchMod_Logo.svg",
    demo: true, // merchmod.ca/demo: the designer as a showcase
    hosts: ["merchmod.ca", "www.merchmod.ca", "merchally.ca", "www.merchally.ca"],
  },
  sportsheadz: {
    id: "sportsheadz",
    name: "Sportsheadz",
    logo: null,        // TODO: Jon's logo file → /merch/stores/sportsheadz/logo.svg
    accent: null,      // TODO: their brand colour (null = MerchMod red)
    hosts: ["design.sportsheadz.com"], // TODO: confirm the address with Jon
    tagline: ["You design it", "We deliver it"],
  },
};

const MERCHMOD_HOSTS = STORES.merchmod.hosts;

function resolve() {
  if (typeof window === "undefined") return STORES.merchmod;
  // ?store=<id> for testing (sticks for this tab); ?store=merchmod clears it
  try {
    const q = new URLSearchParams(window.location.search).get("store");
    if (q && STORES[q]) sessionStorage.setItem("mm_store", q);
    const pinned = sessionStorage.getItem("mm_store");
    if (pinned && STORES[pinned]) return STORES[pinned];
  } catch { /* private mode */ }
  const host = window.location.hostname.toLowerCase();
  return Object.values(STORES).find((s) => s.hosts.includes(host)) || STORES.merchmod;
}

export const STORE = resolve();
export const IS_MERCHMOD = STORE.id === "merchmod";
/** On merchmod.ca the root is the overview; the designer lives at /demo. */
export const ON_MERCHMOD_HOST = typeof window !== "undefined" && MERCHMOD_HOSTS.includes(window.location.hostname.toLowerCase());

// tattune.ca/merch (and local dev) keep the /merch prefix
export const PREFIX = typeof window !== "undefined" && /^\/merch(?=\/|$)/.test(window.location.pathname) ? "/merch" : "";
export const href = (p = "/") => `${PREFIX}${p}`;
/** Where "design" links go: /demo on merchmod.ca, the root everywhere else. */
export const DESIGNER_HREF = ON_MERCHMOD_HOST && IS_MERCHMOD ? href("/demo") : href("/");

/** Apply the store's look (accent, page title) once at startup. */
export function applyStoreTheme() {
  if (typeof document === "undefined") return;
  if (STORE.accent) document.documentElement.style.setProperty("--ma-accent", STORE.accent);
  document.title = IS_MERCHMOD ? "MerchMod — design your gear" : `${STORE.name} — design your gear`;
}
